{
  "name": "composer",
  "version": "0.6.0-pre.8",
  "description": "This Mario Paint inspired composer tool is easy and fun. Create amazing tunes and share them with the world!",
  "main": "dist/main.js",
  "scripts": {
    "start": "bash build/start.sh",
    "build": "bash build/build.sh",
    "test": "bash build/test.sh",
    "test:node": "c8 mocha",
    "smoke": "node test/smoke/live.mjs",
    "test:browser": "node --import @danielx/civet/register test/browser/run.civet"
  },
  "author": {
    "name": "DanielXMoore"
  },
  "devDependencies": {
    "@danielx/civet": "0.11.2",
    "@danielx/dui": "workspace:*",
    "@danielx/lib": "workspace:*",
    "@danielx/observable": "workspace:*",
    "@danielx/song-structure": "workspace:*",
    "@grame/faustwasm": "0.18.4",
    "@playwright/test": "1.45.2",
    "@types/mocha": "^10.0.6",
    "@types/serviceworker": "^0.0.86",
    "c8": "11.0.0",
    "css.escape": "^1.5.1",
    "dexie": "^4.0.7",
    "esbuild": "0.27.3",
    "jadelet": "workspace:*",
    "jsdom": "^24.0.0",
    "mocha": "11.7.5",
    "pixi.js": "6.1.2",
    "stylus": "^0.63.0",
    "typescript": "^5.8.3"
  },
  "mocha": {
    "require": [
      "@danielx/civet/register",
      "jadelet/register",
      "./test/helper.civet"
    ],
    "extension": [
      "civet"
    ],
    "reporter": "spec",
    "recursive": true,
    "spec": [
      "test",
      "source/**/test/**/*"
    ],
    "ignore": [
      "source/test/setup.civet",
      "source/test/perf.civet",
      "source/test/web-audio.civet",
      "source/test/tools-browser.civet",
      "source/lib/test/encoder/index.civet",
      "source/lib/test/legacy/**",
      "test/audio-worklet.civet",
      "test/browser/**",
      "test/run-all.civet"
    ]
  },
  "c8": {
    "extension": [
      ".civet"
    ],
    "include": [
      "source"
    ],
    "exclude": [
      "source/test/**",
      "source/**/test/**"
    ],
    "exclude-after-remap": true,
    "reporter": [
      "text",
      "lcov"
    ]
  }
}
